import i18n, {loadLocaleMessagesAsync} from "@/i18n";
import Navbar from "@/components/navbar/Navbar.vue"
import ProjectDetailHero from "@/components/projectDetailHero/ProjectDetailHero.vue";
import AlternateCards from "@/components/alternateCards/AlternateCards.vue";
import PlainTitleText from "@/components/plainTitleText/PlainTitleText.vue";
import CenteredTitle from "@/components/centeredTitle/CenteredTitle.vue";
import TitleTextImage from "@/components/titleTextImage/TitleTextImage.vue";
import SingleVideo from "@/components/singleVideo/SingleVideo.vue";
import Benefits from "@/components/benefits/Benefits.vue";
import VideoGrid from "@/components/videoGrid/VideoGrid.vue";
import CorrelatedProjects from "@/components/correlatedProjects/CorrelatedProjects.vue";
import VideoGallery from "@/components/videoGallery/VideoGallery.vue";
import Gallery from "@/components/gallery/Gallery.vue";

export default {
    name: "ProjectDetail",
    data() {
        return {
            project: {},
            projectContent: null,
            correlatedProjects: null,
            urbanSectors: []
        };
    },
    mounted() {
        this.project = this.$store.getters.getProjectById(this.$route.params.projectId);
        this.correlatedProjects = this.$store.getters.getCorrelatedProjectsFromProject(this.project);
        this.projectContent = i18n.t("projects." + this.project.id);
    },
    computed: {},
    components: {
        Navbar,
        ProjectDetailHero,
        AlternateCards,
        PlainTitleText,
        CenteredTitle,
        TitleTextImage,
        SingleVideo,
        Benefits,
        CorrelatedProjects,
        VideoGrid,
        VideoGallery,
        Gallery
    }
};
